<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-md>
      <ModelTitle title="Assign Student" @close="close()" />
      <v-card-text>
        <v-row v-if="Teacher">
          <v-col cols="12" sm="12">
            <div>
              Teacher: <span class="font-weight-bold">{{ Teacher.name }}</span>
            </div>
            <div v-if="Teacher.phoneNumber">
              Phone Number:
              <span class="font-weight-bold">{{ Teacher.phoneNumber }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="10">
            <v-autocomplete
              dense
              autofocus
              hide-details
              :items="Students"
              clearable
              item-text="fullName"
              v-model="selectedStudent"
              return-object
              label="Student"
              outlined
              ><template slot="item" slot-scope="{ item }">
                <span>{{ item.fullName }}</span>
                <v-spacer></v-spacer>
                <v-chip
                  color="grey lighten-3"
                  v-if="item.StudentTeachers.length"
                >
                  <v-avatar left class="grey lighten-2">
                    <v-icon small>mdi-human-male-board</v-icon>
                  </v-avatar>
                  <span>{{ item.StudentTeachers.length }}</span>
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn
              @click="addStudent"
              :disabled="!selectedStudent"
              color="success"
              >Add</v-btn
            >
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-list class="list-350">
              <template v-for="(row, index) in StudentList">
                <v-list-item :key="index">
                  <v-list-item-avatar>
                    <v-btn icon
                      ><v-icon color="red" @click="deleteRow(row)"
                        >delete</v-icon
                      ></v-btn
                    >
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span>{{ row.Student.fullName }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <!-- <v-btn color="accent" :loading="loading" dark @click="submit()"
          >Update</v-btn
        > -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import teacherService from "../service.js";
import studentService from "@/modules/Student/service.js";

export default {
  props: {
    editDialog: {
      default: false,
    },
    editTeacher: {
      type: Object,
    },
  },
  name: "update-Teacher",
  data() {
    return {
      StudentList: [],
      Students: [],
      selectedStudent: null,
      loading: false,
      dialog: false,
      Teacher: null,
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.Teacher.name.$dirty) return errors;
      if (!this.$v.Teacher.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  watch: {
    editDialog(val) {
      this.Teacher = this.editTeacher;
      this.dialog = val;
    },
    dialog(val) {
      if (val) {
        this.getTeacher();
        this.getStudents();
      }
    },
  },
  methods: {
    deleteRow(row) {
      console.log("row", row);
      this.$swal({
        title: "Are you sure?",
        text: `You want to remove ${row.Student.fullName} from ${this.Teacher.name} class.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          teacherService.removeStudent(row.id).then((response) => {
            if (response.data) {
              const studentId = (element) => element.id === row.id;

              let i = this.StudentList.findIndex(studentId);
              this.StudentList.splice(i, 1);
              this.$swal(
                "Remove!",
                "Student has been remove from this teacher.",
                "success"
              );
              this.getStudents();
            }
          });
        }
      });
    },
    async addStudent() {
      let found = false;
      await Promise.all(
        this.StudentList.map((student) => {
          if (student.id === this.selectedStudent.id) found = true;
        })
      );
      if (!found) {
        // this.students.push({id: this.selectedStudent.id})
        let obj = {
          TeacherId: this.Teacher.id,
          StudentId: this.selectedStudent.id,
        };
        teacherService
          .assignStudent(obj)
          .then((result) => {
            this.StudentList.push(result.data);
            this.getStudents();
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      } else {
        this.$swal({
          title: "Already exist!",
          text: `${this.selectedStudent.name} is already in this list`,
          icon: "warning",
        });
      }

      this.selectedStudent = null;
    },
    getStudents() {
      return studentService.getAll().then((response) => {
        this.Students = response.data;
        return response;
      });
    },
    getTeacher() {
      return teacherService.getById(this.Teacher.id).then((response) => {
        this.Teacher = response.data;
        if (response.data.StudentTeachers.length) {
          this.StudentList = response.data.StudentTeachers;
        }

        return response;
      });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Teacher = {
        name: null,
      };
      this.StudentList = [];
      this.Students = [];
    },
  },
};
</script>

<style scoped></style>
